import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Row } from 'antd'
import { OperationLog } from 'common/models'
import { BreadcrumbNavigation } from 'components/molecules'
import React, { useMemo } from 'react'

import { BreadcrumbArea } from '../styles'
import { HeaderTitle } from './header-title'

type HeaderProps = {
  onModalClose: () => void
  logItem: OperationLog
}

export const Header = ({ onModalClose, logItem }: HeaderProps) => {
  const breadcrumbModalClose = useMemo(
    () => <BreadcrumbNavigation.CloseIconTemplate onCloseClick={onModalClose} />,
    [onModalClose]
  )

  return (
    <>
      <div className="help">
        <FontAwesomeIcon style={{ color: '#7C8291', fontSize: 20 }} icon={faQuestionCircle} />
      </div>
      <BreadcrumbArea>
        <Row>
          <Col flex="1 1" style={{ minWidth: 0 }}>
            <BreadcrumbNavigation
              customBackElement={breadcrumbModalClose}
              sectionName={<HeaderTitle logItem={logItem} />}
            />
          </Col>
        </Row>
      </BreadcrumbArea>
    </>
  )
}
